var wi_ajax_url = "https://sellyourbags.com/api/";
var wi_admin_url = wi_ajax_url+"wp-admin/";
var wi_api_url = wi_ajax_url+"wp-json/wp/v2/";
$.fn.textWidth = function(text, font) {    
    if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);    
    $.fn.textWidth.fakeEl.text(text || this.val() || this.text() || this.attr('placeholder')).css('font', font || this.css('font'));    
    return $.fn.textWidth.fakeEl.width();
};



(function($) {
    'use strict';

    jQuery(document).ready(function() {

    	//dunamic width
		$('.selected-text input').on('change', function() {
		    var inputWidth = $(this).textWidth();
		    $(this).css({
		        width: inputWidth+20
		    })
		}).trigger('change');

		function inputWidth(elem, minW, maxW) {
		    elem = $(this);
		}
		var targetElem = $('.selected-text input');
		inputWidth(targetElem);

		// Search filter
		$(".search-filter").on("keyup", function() {
		    var value = $(this).val().toLowerCase();
		    $(".result-ul-group li").filter(function() {
		      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
		    });
		});

        //get texo
        $(document).on('click', 'button[data-endpoint]', function (e) {
            e.preventDefault();

            var $this = $(this);
            var endpoint = $(this).data('endpoint');
            var formData = $( this ).serialize();               

            var data = {
                per_page: 100,
                hide_empty: 0                
            };
         
            $.ajax({
                type: 'get',
                url: wi_api_url+endpoint,
                data: data,                
                beforeSend: function (res) {
                    //$('#ajax_filter_result').addClass('loading'); 
                    $("body").find('.result-ul-group').hide();
                    $('.ajax-loading').show();
                },
                complete: function (res) {
                    //$('#ajax_filter_result').removeClass('loading');
                    $('.ajax-loading').hide();
                },
                success: function (res) {
                	console.log("data:",res);
                	var html = "";
                    if(res.length>0){
						Object.keys(res).forEach(function(key) {
							var image = "";
							var desc = "";
							var classes = "noimg";

							// Try image
							try{
								if(res[key].acf.upload_image){
									image = '<img src="'+res[key].acf.upload_image+'" class="imglabel" />';
									classes = 'hasimg';
								}
							}
							catch(err) {
							  console.log(err.message);
							}

							// Try Description
							try{								
								if(endpoint=='size' && res[key].description != ""){
									desc = ' <sub>('+res[key].description+')</sub>';
								}else if(endpoint=='condition' && res[key].description != ""){
									desc = res[key].description;
								}
							}
							catch(err) {
							  console.log(err.message);
							}

							// Try Gallery for cond
							try{
								var slkslider = "";
								var thumb = "";

								if(res[key].acf.bag_examples){
									var bagex = res[key].acf.bag_examples;

									thumb += '<div class="feature_thumb">';
									slkslider += '<div class="feature_thumb_slider">';								

									Object.keys(bagex).forEach(function(bagkey) {										
										slkslider += '<div data-slide="'+bagkey+'"><div class="baght">'+bagex[bagkey].header_texts+'</div><img data-lazy="'+bagex[bagkey].bag_image+'"/></div>';

										if(bagex[bagkey].use_for_thumbnail){
											thumb += '<a data-slide="'+bagkey+'"><img src="'+bagex[bagkey].bag_image+'"/></a>';
										}
									});

									slkslider += '</div>';
									thumb += '</div><div class="rbg-popup__button-group-subtitle--condition">Click the thumbnails to see examples</div>';
								}

	
								
							}
							catch(err) {
							  console.log(err.message);
							}


						 	//console.log(key, res[key].name);
						 	if( endpoint == "accessories" ){
						 		html += '<li class="'+classes+'">'
						 		+'<div>'+res[key].name+desc+'</div>'
						 		+'<div class="label-grp"><label><input type="checkbox" name="slt-designer-inp" value="'+res[key].name+'"> Yes</label>'
						 		+'<label><input type="checkbox" name="slt-designer-inp" value=""> No</label></div>'
						 		+'</li>';
						 	}else if( endpoint == "condition" ){
						 		html += '<li class="rbg-popup__button-group--condition '+classes+'"><div class="condinner">'
						 		+'<div class="mod_cond_desc">'+desc+'</div>'
						 		+'<div class="mod_cond_thumb">'+slkslider+thumb+'</div>'
						 		+'<div class="label-btn"><label class="btn"><input type="radio" name="slt-designer-inp" value="'+res[key].name+'"> <span>Select '+res[key].name+'</span></label></div>'
						 		+'</div></li>';
						 	}else{
						 		html += '<li class="'+classes+'"><label>'+image+'<input type="radio" name="slt-designer-inp" value="'+res[key].name+'"> <span>'+res[key].name+desc+'</span></label></li>';
						 	}
						  	
						});
                    }

                    $("#select-"+endpoint+"-modal").find('.result-ul-group').html(html).slideDown();
                   
                   console.log(res.length);
                },
            });

            return false;
        }); //.get texo

        // get triggered product
        $(document).on('load_products', function () {
            var data = {};
            data.per_page=50;

        	
        	//data["search"]="";
        	
        	var selected_designer = $('.selected-designer').val();
        	if(selected_designer){
        		data["filter[designer]"] = selected_designer;
        	}

        	var selected_model = $('.selected-model').val();
        	if(selected_model){
        		data["filter[model]"] = selected_model;
        	}

        	var selected_material_style = $('.selected-material_style').val();
        	if(selected_material_style){
        		data["filter[material_style]"] = selected_material_style;
        	}

        	var selected_size = $('.selected-size').val();
        	if(selected_size){
        		data["filter[size]"] = selected_size;
        	}

        	var selected_color = $('.selected-color').val();
        	if(selected_color){
        		data["filter[color]"] = selected_color;
        	}

        	var selected_accessories = $('.selected-accessories').val();
        	if(selected_accessories){
        		data["filter[accessories]"] = selected_accessories;
        	}

        	var selected_condition = $('.selected-condition').val();
        	if(selected_condition){
        		data["filter[condition]"] = selected_condition;
        	}

            var $this = $(this);
            var endpoint = "products";

            var pslider = $(".ajax-selective-product");

            console.log(data);
            $.ajax({
                type: 'get',
                url: wi_api_url+endpoint,
                data: data,                
                beforeSend: function (res) {
                    //$('#ajax_filter_result').addClass('loading'); 
                    
                    $('.prd-ajax-loading').show();
					try {
					  pslider.slick('unslick');
					}
					catch(err) {
					  console.log(err.message);
					}
                },
                complete: function (res) {
                    //$('#ajax_filter_result').removeClass('loading');
                    $('.prd-ajax-loading').hide();
                },
                success: function (res) {
                	console.log(res);
                	var html = "";
                	var button = '<button class="sell-flow__carousel__card__button btn">SELECT</button>';
                    if(res.length>0){
                    	if(selected_condition){
                    		process_selected_bag_offer(res[0].id);
                    		return;
                    	}
						Object.keys(res).forEach(function(key) {
						 //console.log(key, res[key].name);
						  
						  html += '<div class="single-slide"> <div class="single-prod" data-id="'+res[key].id+'"> <div class="img-area"><img src="'+res[key].featured_image_src+'"></div><div class="sell-flow__carousel__card__title"><span>'+res[key].title.rendered+'<span></div><p class="sell-flow__carousel__card__sku card-text">'+res[key].acf.product_code+'</p>'+button+'</div></div>';					
						});

						$("#clair-offer").find('.ajax-selective-product').html(html);
				        pslider.slick({
						  infinite: 0,
						  slidesToShow: 5,
						  slidesToScroll: 1,
						  //lazyLoad: 'ondemand'
						});
                    }else{
                    	$("#clair-offer").find('.ajax-selective-product').removeClass('owl-carousel owl-theme').html("<h2>Sorry No Bags Found. Try different filters</h2>");
                    }
					
                },
            });

            return false;
        });

		// Reveal Button		
		$(document).on('click','.reveal-offer span', function () {
			$(this).parent().parent().addClass('reveal');
			$('.instant-offer__cta--instant-offer').slideDown();
		});

        // get product view
        $(document).on('click','.sell-flow__carousel__card__button', function () {
        	var id = $(this).closest('.single-prod').data('id');  
        	process_selected_bag_offer(id);
        });

        // Process selected
        function process_selected_bag_offer(id){

        	//var id = $(this).closest('.single-prod').data('id');           
            var endpoint = "products/"+id;           

            $.ajax({
                type: 'get',
                url: wi_api_url+endpoint,
                beforeSend: function (res) {
                    //$('#ajax_filter_result').addClass('loading');                     
                    $('.prd-ajax-loading').show();
                    $('.instant-offer__cta--instant-offer').hide();
                },
                complete: function (res) {
                    //$('#ajax_filter_result').removeClass('loading');
                    $('.prd-ajax-loading').hide();
                },
                success: function (res) {
                	console.log(res);
                	var html = "";
                	
                    if(res){
						  
						html += '<div class="sell-flow-offer__body" data-prod-id="'+res.id+'"><div class="sell-flow-offer__container-img-parent"><img title="Your Offer" src="'+res.featured_image_src+'" class="sell-flow-offer__container-img"></div><div class="sell-flow-offer__container-text"><h4 class="sell-flow-offer__container-title">'+res.acf.designer.name+'</h4><div class="sell-flow-offer__container-subtitle">'+res.acf.model.name+' - '+res.acf.material_style.name+' - '+res.acf.size.name+' - '+res.acf.color.name+' - '+res.acf.condition.name+'</div><div class="sell-flow-offer__container-sku-container" style="display:none"><span class="sell-flow-offer__container-sku-label">CLAIR CODE</span><span class="sell-flow-offer__container-sku">'+res.acf.product_code+'</span></div></div></div><div class="sell-flow-offer__footer"><div class="reveal-offer"><span class="btn">REVEAL INSTANT OFFER</span></div><div class="sell-flow-offer__footer-button"><div class="sell-flow-offer__footer-title">ACH OR CHECK</div><div class="sell-flow-offer__footer-price"><span>$'+res.acf.cheque_offer_price+'</span></div><div class="sell-flow-offer__footer-subtitle"><span>'+res.acf.parcent_of_est_retail_price_for_cheque+'% of est. retail price</span></div></div><div class="sell-flow-offer__footer-or">OR</div><div class="sell-flow-offer__footer-button"><div class="sell-flow-offer__footer-title">DALLAS CREDIT</div><div class="sell-flow-offer__footer-price"><span>$'+res.acf.credit_offer_price+'</span></div><div class="sell-flow-offer__footer-subtitle"><span>'+res.acf.parcent_of_est_retail_price_for_credit+'% of est. retail price</span></div></div></div>';
						  
						
						$('.offer-ajax-res').html(html);
						$("html, body").animate({ scrollTop: 0 }, "slow");
						$('.offer-wrap').slideDown();
						$('.query-wrap').hide();
                    }
					
                },
            });

            return false;
        }

        // Search form product
        $('.sell-flow__top__search-input').on('focus',function(){
        	$('.sell-flow__breadcrumbs-container').fadeOut();
        	$('.btnsearch-wrap').fadeOut();
        });

        $('.sell-flow__top__close-icon').on('click',function(){
        	$('.sell-flow__breadcrumbs-container').fadeIn();
        	$('.btnsearch-wrap').fadeIn();
        });


        // get product
        $(document).on('keyup','.sell-flow__top__search-input', function () {
        	
        	var endpoint = "products";
            var pslider = $(".ajax-selective-product");

            var data = {};
            data.per_page=50;        	
        	
        	var thisval = $(this).val();
        	if(thisval){
        		data["search"] = thisval;
        	}else{
        		return;
        	}

            console.log(data);
            $.ajax({
                type: 'get',
                url: wi_api_url+endpoint,
                data: data,                
                beforeSend: function (res) {
                    //$('#ajax_filter_result').addClass('loading'); 
                    
                    $('.prd-ajax-loading').show();
					try {
					  pslider.slick('unslick');
					}
					catch(err) {
					  console.log(err.message);
					}
                },
                complete: function (res) {
                    //$('#ajax_filter_result').removeClass('loading');
                    $('.prd-ajax-loading').hide();
                },
                success: function (res) {
                	console.log(res);
                	var html = "";
                	var button = '<button class="sell-flow__carousel__card__button btn">SELECT</button>';
                    if(res.length>0){
						Object.keys(res).forEach(function(key) {
						 //console.log(key, res[key].name);
						  
						  html += '<div class="single-slide"> <div class="single-prod" data-id="'+res[key].id+'"> <div class="img-area"><img data-lazy="'+res[key].featured_image_src+'"></div><div class="sell-flow__carousel__card__title"><span>'+res[key].title.rendered+'<span></div><p class="sell-flow__carousel__card__sku card-text">'+res[key].acf.product_code+'</p>'+button+'</div></div>';					
						});

						$("#clair-offer").find('.ajax-selective-product').html(html);
				        pslider.slick({
						  infinite: 0,
						  slidesToShow: 5,
						  slidesToScroll: 1,
						  lazyLoad: 'ondemand'
						});
                    }else{
                    	$("#clair-offer").find('.ajax-selective-product').removeClass('owl-carousel owl-theme').html("<h2>Sorry No Bags Found. Try different keywords</h2>");
                    }
					
                },
            });

            return false;
        });


        // clear selected
        $(document).on('click','.clearthis',function(){
        	$(this).parent().find('input').val("");
        	$(this).parent().hide().parent().find('button').show();
        	$(document).trigger('load_products');
        });

        // Re Selection
        $(document).on('click','.selected-text, .edit-pen',function(){
        	$(this).parent().parent().find('button').click();
        });


        // Designer Modal Input Selection
        $(document).on('change',"#select-designer-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-designer').val(thisval).trigger('change');
        	$('#select-designer').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-designer-modal").find('.close').click();
        	$("#select-model").prop('disabled',false);
        	$("#select-material_style").prop('disabled',true);
        	$("#select-size").prop('disabled',true);
        	$("#select-color").prop('disabled',true);
        	$("#select-accessories").prop('disabled',true);
        	$("#select-condition").prop('disabled',true);
        });

        // Model Modal Input Selection
        $(document).on('change',"#select-model-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-model').val(thisval).trigger('change');
        	$('#select-model').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-model-modal").find('.close').click();
        	//$("#select-model").prop('disabled',false);
        	$("#select-material_style").prop('disabled',false);
        	$("#select-size").prop('disabled',true);
        	$("#select-color").prop('disabled',true);
        	$("#select-accessories").prop('disabled',true);
        	$("#select-condition").prop('disabled',true);
        });

        // Material Modal Input Selection 
        $(document).on('change',"#select-material_style-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-material_style').val(thisval).trigger('change');
        	$('#select-material_style').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-material_style-modal").find('.close').click();
        	//$("#select-model").prop('disabled',false);
        	//$("#select-material_style").prop('disabled',false);
        	$("#select-size").prop('disabled',false);
        	$("#select-color").prop('disabled',true);
        	$("#select-accessories").prop('disabled',true);
        	$("#select-condition").prop('disabled',true);
        });

        // Size Input Selection 
        $(document).on('change',"#select-size-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-size').val(thisval).trigger('change');
        	$('#select-size').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-size-modal").find('.close').click();
        	$("#details-tab").click();
        	//$("#select-model").prop('disabled',false);
        	//$("#select-size").prop('disabled',false);        	
        	$("#select-color").prop('disabled',false);
        	$("#select-accessories").prop('disabled',true);
        	$("#select-condition").prop('disabled',true);
        });

        // Color Input Selection 
        $(document).on('change',"#select-color-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-color').val(thisval).trigger('change');
        	$('#select-color').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-color-modal").find('.close').click();
        	
        	//$("#select-model").prop('disabled',false);
        	//$("#select-size").prop('disabled',false);        	
        	//$("#select-color").prop('disabled',false);
        	$("#select-accessories").prop('disabled',false);
        	$("#select-condition").prop('disabled',true);
        });

        // accessories Input Selection 
        $(document).on('change',"#select-accessories-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-accessories').val(thisval).trigger('change');
        	$('#select-accessories').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-accessories-modal").find('.close').click();
        	
        	//$("#select-model").prop('disabled',false);
        	//$("#select-size").prop('disabled',false);        	
        	//$("#select-color").prop('disabled',false);
        	//$("#select-accessories").prop('disabled',true);
        	$("#select-condition").prop('disabled',false);
        });

        // condition Input Selection 
        $(document).on('change',"#select-condition-modal input:not(.search-filter)",function(){
        	var thisval = $(this).val();
        	$('.selected-condition').val(thisval).trigger('change');
        	$('#select-condition').hide().parent().find('.selected-layout').show();
        	$(this).closest("#select-condition-modal").find('.close').click();
        	
        	//$("#select-model").prop('disabled',false);
        	//$("#select-size").prop('disabled',false);        	
        	//$("#select-color").prop('disabled',false);
        	//$("#select-accessories").prop('disabled',true);
        	//$("#select-condition").prop('disabled',true);
        	
        });

        // Change to trigger
        $(document).on('change',"#clair-offer input:not(.search-filter)",function(){
        	$(document).trigger('load_products');
        });

        $(document).on('click','.instant-offer__cta--instant-offer', function () {
        	var $this = $(this);
        	var endpoint = "offers";
        	var email = $(this).closest('#clair-offer').data('email');
        	var name = $(this).closest('#clair-offer').data('name');
        	var product_id = $(this).closest('#clair-offer').find('.sell-flow-offer__body').data('prod-id');

        	var content = "Name: "+name+"<br>";
        	content += "Email: "+email+"<br>";
        	content += "Product Id: "+product_id+"<br>";
        	content += "<a target='_blank' href="+wi_admin_url+"post.php?post="+product_id+"&action=edit>See Product Details</a><br>";

            var data = {
                title: "Offer #"+product_id+" : "+name,
                content: content,
                status: "publish",
                email:email,
                name:name,
                product_id:product_id
            };

            console.log(data);
            $.ajax({
                type: 'POST',
                url: wi_api_url+endpoint,
                data: data,
                //crossDomain: true,
				//contentType: 'application/json',
                beforeSend: function (xhr) {
                    //$('#ajax_filter_result').addClass('loading'); 
                    
                    xhr.setRequestHeader( 'Authorization', "Basic YmFzaWM6YmFzaWMjMzIx" );
                    $this.prop('disabled',true).html('Sending your request');
                    //$(".ajax-msg").html('Sending your request');
					
                },
                complete: function (res) {
                    //$('#ajax_filter_result').removeClass('loading');
                    //$('.prd-ajax-loading').hide();
                },
                success: function (res) {
                	console.log(res);
                	
                	//$(".ajax-msg").html('Success!.');
                	$this.html('Submitted');
					
                },
                error: function (res) {                	
                	$(".ajax-msg").html('Something went wrong');
					
                },
            });

            return false;
        });

        $(document).on('click','.feature_thumb a', function (e) {
        	
        	var sliderhtml = $(this).closest('.mod_cond_thumb').find('.feature_thumb_slider').html();
        	var putslider = $('.push-slider-here');
        	var bagModal = $('#bag-condition-slider-modal');
        	var sliderInitDiv = bagModal.find('.push-slider-here');
        	var slideno = $(this).data('slide');
        	
        	putslider.html(sliderhtml);
        	
        	try {
			  sliderInitDiv.slick('unslick');
			}
			catch(err) {
			  console.log(err.message);
			}

			sliderInitDiv.slick({
			  infinite: 0,
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  lazyLoad: 'ondemand'
			});

			bagModal.modal('toggle');

        	//console.log(sliderhtml);
        	$(window).trigger('resize');

        	sliderInitDiv.slick('slickGoTo', slideno );
        	e.preventDefault();
        });


        $(window).load(function(){
        	$(document).trigger('load_products');
        	console.log("Loading");
        });

    });
    
})(jQuery);
